var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useImageUpload } from "frontend/src/lib/use-image-upload";
export var useCreatePlaylistBusinessTypeForm = function (initial) {
    var _a = __read(React.useState(initial.title), 2), title = _a[0], setTitle = _a[1];
    var _b = useImageUpload({
        file: null,
        image: initial.image,
    }), image = _b.image, onImageChange = _b.onImageChange, resetImage = _b.resetImage, setImage = _b.setImage, file = _b.file;
    var _c = __read(React.useState({}), 2), errors = _c[0], setErrors = _c[1];
    var validate = function () {
        var errorBag = {};
        if (title.length === 0) {
            errorBag.title = "Введите название.";
        }
        if (file === null) {
            errorBag.image = "Выберите изображение.";
        }
        if (file === null || title.length === 0) {
            setErrors(errorBag);
            return { type: "error" };
        }
        setErrors({});
        return { type: "success", validated: { title: title, file: file } };
    };
    var onTitleChange = function (evt) {
        return setTitle(evt.target.value);
    };
    return {
        title: {
            value: title,
            set: setTitle,
            error: errors.title,
            onChange: onTitleChange,
        },
        image: {
            value: image,
            set: setImage,
            onChange: onImageChange,
            reset: resetImage,
            error: errors.image,
        },
        validate: validate,
    };
};
